import React from 'react'
import { RecipeStep } from '@mindfulchefuk/features/Recipes/interfaces'

type TSchemaParams = {
  name: string
  description: string
  image: string
  cookTime: string
  nutritionalInformation: {
    name: string
    value: string | number
  }[]
  ingredients: { display_title: string }[]
  steps: RecipeStep[]
}

type TSchemaObject = {
  '@context': string
  '@type': string
  author: string
  cookTime: string
  name: string
  description: string
  image: string
  recipeIngredient: string[]
  nutrition: {
    '@type': string
    [key: string]: string | number
  }
  recipeInstructions: string
}

const RecipeSchema = ({
  name,
  description,
  image,
  cookTime,
  ingredients,
  nutritionalInformation,
  steps,
}: TSchemaParams) => {
  const schemaObj: TSchemaObject = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    author: 'Mindful Chef',
    cookTime,
    name,
    description,
    image,
    recipeIngredient: [],
    nutrition: {
      '@type': 'NutritionInformation',
    },
    recipeInstructions: '',
  }

  ingredients.forEach((i) => {
    schemaObj.recipeIngredient.push(i.display_title)
  })

  nutritionalInformation.forEach((ni) => {
    schemaObj.nutrition[ni.name] = ni.value
  })

  steps.forEach((s) => {
    schemaObj.recipeInstructions += ` ${s.description}`
  })

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schemaObj),
      }}
    />
  )
}

export default RecipeSchema
